// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import Asset from "components/ui/Asset";
import BarcodePanel from "components/ImageCapture/BarcodePanel";
import CSS from "csstype";
import DeclarativeList from "./DeclarativeList";
import DemoAsset from "components/TestRun/DemoAsset";
import Dialog from "components/ui/Dialog";
import EmailPanel from "components/TestRun/steps/EmailPanel";
import FedExShipping from "components/Shipping/FedEx/FedExShipping";
import { FunctionComponent } from "react";
import MarkDown from "components/ui/MarkDown";
import { NavButton } from "components/ui/Buttons";
import NextStepButton from "components/TestRun/NextStepButton";
import NextStepLink from "components/TestRun/NextStepLink";
import Paragraph from "components/ui/Paragraph";
import PhotoUploaderPanel from "components/ImageCapture/PhotoUploaderPanel";
import RegistrationPanel from "components/TestRun/steps/RegistrationPanel";
import ServerAsset from "components/ui/ServerAsset";
import TestRunWarningDialog from "components/TestRun/TestRunWarningDialog";
import Title from "components/ui/Title";
import WaitStep from "components/TestRun/WaitStep";

export interface DeclarativeItemBase {
  type: allowedDeclarativeComponents | React.FunctionComponent;
  props: { [propName: string]: any };
  display?: displayType;
  wrapperStyle?: CSS.Properties;
}

export type displayType = "normal" | "centered";

export type allowedDeclarativeComponents =
  | "Title"
  | "DeclarativeList"
  | "WaitStep"
  | "Asset"
  | "DemoAsset"
  | "Paragraph"
  | "PhotoUploaderPanel"
  | "BarcodePanel"
  | "NextStepButton"
  | "NextStepLink"
  | "NavButton"
  | "Dialog"
  | "TestRunWarningDialog"
  | "FedExShipping"
  | "RegistrationPanel"
  | "EmailPanel"
  | "MarkDown";

export const getAllowedDeclarativeComponentMapping = (): {
  [componentName: string]:
    | ((props: any) => JSX.Element)
    | FunctionComponent<any>;
} => {
  return {
    WaitStep: WaitStep,
    Paragraph: Paragraph,
    DeclarativeList: DeclarativeList,
    Title: Title,
    Asset: Asset,
    DemoAsset: DemoAsset,
    ServerAsset: ServerAsset,
    PhotoUploaderPanel: PhotoUploaderPanel,
    BarcodePanel: BarcodePanel,
    NextStepButton: NextStepButton,
    NextStepLink: NextStepLink,
    NavButton: NavButton,
    Dialog: Dialog,
    TestRunWarningDialog: TestRunWarningDialog,
    FedExShipping: FedExShipping,
    RegistrationPanel: RegistrationPanel,
    EmailPanel: EmailPanel,
    MarkDown: MarkDown,
  };
};

export type DeclarativeContent = Array<DeclarativeItemBase>;
